import { BFF_NPS_PREFIX, CSRF_COOKIE, ApiError } from '@/shared/api/client';

function readCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

/** Upload multipart para rotas NPS via BFF. */
export async function npsUpload<T>(path: string, formData: FormData, method: 'POST' | 'PATCH' = 'PATCH'): Promise<T> {
  const csrf = readCookie(CSRF_COOKIE);
  const response = await fetch(`${BFF_NPS_PREFIX}${path}`, {
    method,
    credentials: 'same-origin',
    headers: csrf ? { 'X-CSRF-Token': csrf } : {},
    body: formData,
  });

  if (!response.ok) {
    let data: unknown;
    try {
      data = await response.json();
    } catch {
      /* corpo não-JSON */
    }
    const message =
      (data as { message?: string } | undefined)?.message ?? response.statusText ?? 'Erro inesperado';
    throw new ApiError(response.status, message, data);
  }

  const contentType = response.headers.get('content-type') ?? '';
  if (contentType.includes('application/json')) return (await response.json()) as T;
  return (await response.blob()) as T;
}

/** Baixa blob autenticado (foto/banner). */
export async function npsFetchBlob(path: string): Promise<Blob | null> {
  const response = await fetch(`${BFF_NPS_PREFIX}${path}`, { credentials: 'same-origin' });
  if (response.status === 404) return null;
  if (!response.ok) throw new ApiError(response.status, response.statusText);
  return response.blob();
}
